﻿(function (angular) {
  "use strict";

  angular.module("Toyota.Components").component("tyLoadingSpinner", {
    /*
     * See also: IE.Toyota.MainSite.Common/Renderings/Toyota/MainSite/LoadingSpinner.cshtml
     * for the serverside equivalent
     */

    controller: [
      "$scope",
      "$element",
      "$compile",
      function ($scope, $element, $compile) {
        var sizeAttributes = {
          small: "24px",
          medium: "36px",
          large: "52px",
        };

        for (var attributeName in sizeAttributes) {
          if (!Object.prototype.hasOwnProperty.call(sizeAttributes, attributeName)) {
            continue;
          }

          if (typeof $element.attr(attributeName) !== "undefined") {
            $scope.width = sizeAttributes[attributeName];
            $scope.height = sizeAttributes[attributeName];
            break;
          }
        }

        if (typeof $element.attr("bright") !== "undefined") {
          $scope.bright = true;
        }

        // prettier-ignore
        var template =
          '<svg class="ty-svg-icon ty-svg-icon--block ty-loading-spinner" ' +
            "data-ng-class=\"{'ty-loading-spinner--bright': bright}\" " +
            'width="' + $scope.width + '" ' +
            'height="' + $scope.height + '" ' +
            'viewBox="0 0 52 52"' +
          ">" +
            '<g stroke="none" fill-rule="evenodd">' +
              '<path class="ty-loading-spinner__path" d="M52,26 C52,27.104 50.8352,28 49.4,28 L41.6,28 C40.1648,28 39,27.104 39,26 C39,24.896 40.1648,24 41.6,24 L49.4,24 C50.8352,24 52,24.896 52,26 Z"></path>' +
              '<path class="ty-loading-spinner__path" d="M13,26 C13,27.104 11.8352,28 10.4,28 L2.6,28 C1.1648,28 0,27.104 0,26 C0,24.896 1.1648,24 2.6,24 L10.4,24 C11.8352,24 13,24.896 13,26 Z"></path>' +
              '<g transform="translate(26, 26) rotate(-90) translate(-26, -26) translate(0, 24)">' +
                '<path class="ty-loading-spinner__path" d="M52,2 C52,3.104 50.8352,4 49.4,4 L41.6,4 C40.1648,4 39,3.104 39,2 C39,0.896 40.1648,0 41.6,0 L49.4,0 C50.8352,0 52,0.896 52,2 Z"></path>' +
                '<path class="ty-loading-spinner__path" d="M13,2 C13,3.104 11.8352,4 10.4,4 L2.6,4 C1.1648,4 0,3.104 0,2 C0,0.896 1.1648,0 2.6,0 L10.4,0 C11.8352,0 13,0.896 13,2 Z"></path>' +
              "</g>" +
              '<g transform="translate(26, 26) rotate(-135) translate(-26, -26) translate(0, 24)">' +
                '<path class="ty-loading-spinner__path" d="M52,2 C52,3.104 50.8352,4 49.4,4 L41.6,4 C40.1648,4 39,3.104 39,2 C39,0.896 40.1648,0 41.6,0 L49.4,0 C50.8352,0 52,0.896 52,2 Z"></path>' +
                '<path class="ty-loading-spinner__path" d="M13,2 C13,3.104 11.8352,4 10.4,4 L2.6,4 C1.1648,4 0,3.104 0,2 C0,0.896 1.1648,0 2.6,0 L10.4,0 C11.8352,0 13,0.896 13,2 Z"></path>' +
              "</g>" +
              '<g transform="translate(26, 26) rotate(-225) translate(-26, -26) translate(0, 24)">' +
                '<path class="ty-loading-spinner__path" d="M52,2 C52,3.104 50.8352,4 49.4,4 L41.6,4 C40.1648,4 39,3.104 39,2 C39,0.896 40.1648,0 41.6,0 L49.4,0 C50.8352,0 52,0.896 52,2 Z"></path>' +
                '<path class="ty-loading-spinner__path ty-loading-spinner__path--accent" d="M13,2 C13,3.104 11.8352,4 10.4,4 L2.6,4 C1.1648,4 0,3.104 0,2 C0,0.896 1.1648,0 2.6,0 L10.4,0 C11.8352,0 13,0.896 13,2 Z"></path>' +
              "</g>" +
            "</g>" +
          "</svg>";

        $element.replaceWith($compile(template)($scope));
      },
    ],
  });
})(window.angular);
